namespace Matrix.Dashboards {
    export interface DatasetFetchResponse extends Serenity.ServiceResponse {
        Data?: any;
        AggregateFields?: AggregateField[];
        AggregateGroups?: string[];
        Aggregates?: Aggregate[];
        More?: boolean;
        Skip?: number;
        Take?: number;
        TotalCount?: number;
    }
}
